import { Link, NoBreak, Text } from "atoms";
import styled from "@emotion/styled";

type Props = {
  userIsArtist: boolean;
};

function BetaProfileAnnounceMessage({ userIsArtist }: Props) {
  return (
    <GrayBar>
      <Text font="display" size="xs" textAlign="center" style={{ margin: 0 }}>
        Oh hey there! You&apos;ve just stumbled upon one of our new Artist
        Profiles (currently&nbsp;in&nbsp;beta).{" "}
        {userIsArtist && (
          <NoBreak>
            Want to give it a go?&nbsp;&nbsp;
            <Link
              to="https://go.thehug.xyz/betarequest"
              target="_blank"
              size="xxxs"
              variant="primary"
            >
              Request Beta Access
            </Link>
          </NoBreak>
        )}
      </Text>
    </GrayBar>
  );
}
const GrayBar = styled.div(({ theme }) => ({
  color: theme.colors.fg,
  backgroundColor: theme.colors.fg10,
  paddingInline: theme.spacing.gutter,
  paddingBlock: 10,
  a: {
    margin: "4px 0",
  },
}));

export { BetaProfileAnnounceMessage };
